import React, { useEffect, useState } from 'react';
import { Avatar } from '@mui/material';
import { getInitials } from '../../utils/helper-functions';

const hasStudentPhoto = (src) => typeof src === 'string' && src.trim() !== '';

const StudentPhoto = ({ src, name = '', alt, imageClassName, avatarClassName }) => {
    const [loadFailed, setLoadFailed] = useState(false);

    useEffect(() => {
        setLoadFailed(false);
    }, [src]);

    if (hasStudentPhoto(src) && !loadFailed) {
        return (
            <img
                alt={alt || name}
                className={imageClassName}
                src={src}
                onError={() => setLoadFailed(true)}
            />
        );
    }

    return (
        <Avatar
            className={avatarClassName}
            sx={{
                bgcolor: '#246c34',
                fontSize: '2rem',
                fontWeight: 'bold',
            }}
        >
            {getInitials(name)}
        </Avatar>
    );
};

export default StudentPhoto;
